import React, { useEffect, useState } from "react";
import Axios from "axios";
import { getUser } from "../../actions/session";
import {
  ALL_CARRIER_LIST,
  CREATE_RATEDECK_NEW,
  RATEDECK_LIST,
} from "../../config/rest_endpoints";
import Container from "../common/application_container";
import { Notifications } from "../common/notification";
import CustomLoader from "../common/loader";
// import CreateRateDeckForm from "./CreateRateDeckForm";
// import DatePicker from "react-datepicker";
import Select from "react-select";
import MultiSelect from "@khanacademy/react-multi-select";
// datetime picker imports
import DateRangePicker from "react-bootstrap-daterangepicker";
import moment from "moment";
import CustomModal from "../common/modal";
import { Link } from "react-router-dom/cjs/react-router-dom";


const CreateRateDeckIndex = () => {
  const [User] = useState(getUser());
  const [isTollFree, setisTollFree] = useState(false);
  const [isLoad, setisLoad] = useState(false);
  const [date, setDate] = useState(new Date());

  const [carriersOption, setcarriersOption] = useState([]);
  const [selectedCarriers, setselectedCarriers] = useState([]);

  const [state, setState] = useState({
    fileName: "",
    deviation: "",
    indeterminateValue: "",
    costPrice: 1,
  });

  const [roundingDigits] = useState([
    { label: 2, value: 2 },
    { label: 3, value: 3 },
    { label: 4, value: 4 },
    { label: 5, value: 5 },
    { label: 6, value: 6 },
  ]);
  const [roundingDigitsSelect, setRoundingDigitSelect] = useState({
    label: 6,
    value: 6,
  });

  const [roundingMethod] = useState([{ label: "Round up", value: "*up" }]);
  const [roundingMethodSelect, setRoundingMethodSelect] = useState({
    label: "Round up",
    value: "*up",
  });

  const [costPlaceSelect, setCostPlaceSelect] = useState({
    label: "1st",
    value: 1,
  });

  const [costPlace] = useState([
    { label: "1st", value: 1 },
    { label: "2nd", value: 2 },
    { label: "3rd", value: 3 },
    { label: "4th", value: 4 },
    { label: "5th", value: 5 },
  ]);

  const [indeterminateAsSelect, setIndeterminateAsSelect] = useState({
    label: "True-LCR of Carrier Indeterminate",
    value: "True-LCR of Carrier Indeterminate",
  });

  const [indeterminateAs] = useState([
    { label: "Copy of Intrastate", value: "Copy of Intrastate" },
    { label: "Copy of Interstate", value: "Copy of Interstate" },
    { label: "Higher of Inter/Intra", value: "Higher of Inter/Intra" },
    { label: "Lower of of Inter/Intra", value: "Lower of of Inter/Intra" },
    {
      label: "True-LCR of Carrier Indeterminate",
      value: "True-LCR of Carrier Indeterminate",
    },
  ]);

  const [list, setList] = useState([]);
  const [isGetting, setisGetting] = useState(false);
  const [carrierShow, setCarrierShow] = useState(false);
  const [carrierName, setCarrierName] = useState([]);
  const [search, setSearch] = useState('')

  useEffect(() => {
    getCarriers();
    getList();
  }, []);

  const searchSpace = (e) => {
    setSearch(e.target.value);
  };

  const openModal = (data) => {
    const list = data.split(",") || [];
    setCarrierName(list);
    setCarrierShow(true);
  };
  const closeModal = () => setCarrierShow(false);

  const stateHandle = (e) => {
    const { name, value } = e.target;
    console.log(`name,value`, name, value);
    setState((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const getCarriers = () => {
    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(ALL_CARRIER_LIST, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data.data;
          const list = resp.map((row) => {
            let obj = {
              label: row.name,
              value: row.domain,
            };
            return obj;
          });
          setcarriersOption(list || []);
          setselectedCarriers(list.map((item) => item["value"]) || []);
        }
      })
      .catch((err) => {
        const msessage = err.response.data.message;
        console.log(`err`, err);
        Notifications.notify(msessage, "Failed", "error");
      });
  };

  const getList = () => {
    setisGetting(true);
    var headers = { Authorization: "Bearer " + User.token };
    Axios.get(RATEDECK_LIST, { headers })
      .then((res) => {
        if (res) {
          const resp = res.data.data;
          setList(resp);
          setisGetting(false);
          console.log("resp", resp);
        }
      })
      .catch((err) => {
        const msessage = err.response.data.message;
        console.log(`err`, err);
        setisGetting(false);
        Notifications.notify(msessage, "Failed", "error");
      });
  };

  const handleSubmit = () => {
    const payload = {
      carrierIDs: selectedCarriers,
      margin: parseFloat(state.margin),
      includeTFNs: isTollFree,
      tfnsPrice: parseFloat(state.tollFreePrice),
      costPlace: parseInt(costPlaceSelect.value),
      maxDeviation: state.deviation,
      minProfit: parseFloat(state.minProfit),
      fileName: state.fileName,
      indeterminateValue: indeterminateAsSelect.value,
      roundingMethod: roundingMethodSelect.value,
      roundingDigits: parseInt(roundingDigitsSelect.value),
      effectiveDate: date.toISOString(),
      // "effectiveDate": moment(date).format('MM/DD/YYYY, h:mm:ss A')
    };

    setisLoad(true);
    var headers = { Authorization: "Bearer " + User.token };
    Axios.post(CREATE_RATEDECK_NEW, payload, { headers })
      .then((res) => {
        if (res) {
          var resp = res.data;
          console.log(`resp`, resp);
          // Create a blob
          var blob = new Blob([resp], { type: "text/csv;charset=utf-8;" });
          var url = URL.createObjectURL(blob);

          // Create a link to download it
          var pom = document.createElement("a");
          pom.href = url;
          pom.setAttribute("download", state.fileName);
          pom.click();
          setisLoad(false);
          Notifications.notify(
            "Successfully created the ratedeck",
            "Created",
            "success"
          );
          getList();
        }
      })
      .catch((err) => {
        const msessage = err.response.data.message;
        Notifications.notify(msessage, "Failed", "error");
        setisLoad(false);
      });
  };

  const renderAccountTable = () => {
    var nullData = (
      <div className="ml-4 mt-2">
        <div
          className="dataTables_info"
          id="DataTables_Table_0_info"
          role="status"
          aria-live="polite"
        >
          Showing 0 of 0 entries
        </div>
        <div
          className="dataTables_paginate paging_simple_numbers"
          id="DataTables_Table_0_paginate"
        ></div>
      </div>
    );

    if (!list.length) {
      return nullData;
    } else {
      return list
        .filter((table) => {
          if (search === null) {
            return table;
          } else if (
            table.fileName.toLowerCase().includes(search.toLowerCase())
          ) {
            return table;
          }
        })
        .map((row, idx) => {
          return (
            <tr key={idx}>
              <td
                style={{ textAlign: "center" }}
                onClick={() => openModal(row.carriers)}
              >
                <Link>
                  <i className=" icon-eye-plus  icon-1x">
                    {/* {row.carriers}  */}
                  </i>
                </Link>
              </td>
              <td style={{ textAlign: "center" }}>{row.fileName}</td>
              <td style={{ textAlign: "center" }}>{row.tfnsPrice}</td>
              <td style={{ textAlign: "center" }}>{row.roundingMethod}</td>
              <td style={{ textAlign: "center" }}>{row.roundingDigits}</td>
              <td style={{ textAlign: "center" }}>{row.minProfit}</td>
              <td style={{ textAlign: "center" }}>{row.maxDeviation}</td>
              <td style={{ textAlign: "center" }}>{row.margin}</td>
              <td style={{ textAlign: "center" }}>{row.indeterminateValue}</td>
              <td style={{ textAlign: "center" }}>
                {row.includeTFNs ? "True" : "false"}
              </td>
              <td style={{ textAlign: "center" }}>
                {moment(row.createDate).format("MM-DD-YYYY HH:mm")}
              </td>
            </tr>
          );
        });
    }
  };

  let CarrierModal = {
    details: {
      info: `Carriers List`,
      msg: (
        <div
          className="datatable-scroll"
          style={{ maxHeight: "50em", overflowY: "auto" }}
        >
          <table
            className="table-style table table-striped dataTable no-footer"
            id="DataTables_Table_0"
            role="grid"
            aria-describedby="DataTables_Table_0_info"
          >
            <thead>
              <tr className="stickeyHeader table-heading-style">
                <th>No.</th>
                <th>Selected List</th>
              </tr>
            </thead>
            <tbody>
              {carrierName.length &&
                carrierName.sort().map((item, idx) => {
                  return (
                    <tr key={idx}>
                      <td className="text-center">{idx + 1}</td>
                      <td className="text-center">{item}</td>
                    </tr>
                  );
                })}
              {/* {isGetting ? <CustomLoader /> : this.__renderAccountTable()}
                                {tableData.length > 0 ? this.returnTotal() : ''} */}
            </tbody>
          </table>
        </div>
      ),
    },
    confirmBtn: { label: "Update", action: "" },
    crossBtn: { action: closeModal },
    cancelBtn: { label: "Cancel", action: closeModal },
  };

  return (
    <Container title="Create Ratedeck" title1="Table" icon="fa fa-credit-card">
      <CustomModal
        visibility={carrierShow}
        customBodyCSS={"h20"}
        noOverFLow={true}
        modalSize={""}
        modalType={"success"}
        details={CarrierModal.details}
        showBtns={false}
        cancelBtn={CarrierModal.cancelBtn}
        crossBtn={CarrierModal.crossBtn}
      />
      <div
        style={{
          border: "none",
          borderRadius: "5px",
          boxShadow: "0 0 20px rgba(0,0,0,.08)",
        }}
        className="card card-body"
      >
        <div className="card-header header-elements-inline p-0 py-1 mb-1">
          <h5
            style={{ fontWeight: "700", fontSize: "24px" }}
            className="card-title"
          ></h5>
          <div className="header-elements"></div>
        </div>
        <div className="row">
          <div className="col-md-4">
            <fieldset>
              <legend class="font-weight-semibold">
                <i class="icon-reading mr-2"></i> Carriers
              </legend>
              <div class="form-group w-100">
                <label>All Carriers:</label>
                <MultiSelect
                  options={carriersOption}
                  selected={selectedCarriers}
                  onSelectedChanged={(selectedCarriers) =>
                    setselectedCarriers(selectedCarriers)
                  }
                  overrideStrings={{
                    selectSomeItems: "Filter Carrier",
                    allItemsAreSelected: "All Carrier are Selected",
                    selectAll: "Select All Carrier",
                    search: "Search Carrier",
                  }}
                />
              </div>
            </fieldset>
          </div>
          {/* column 1 */}
          <div className="col-md-4">
            <fieldset>
              <legend class="font-weight-semibold">
                <i class="icon-reading mr-2"></i> Details
              </legend>

              <div class="form-group">
                <label>File Name:</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={stateHandle}
                  name="fileName"
                  value={state.fileName}
                  placeholder=""
                />
              </div>

              <div class="form-group">
                <label>Max Deviation:</label>
                <input
                  type="text"
                  class="form-control"
                  onChange={stateHandle}
                  name="deviation"
                  value={state.deviation}
                  placeholder=""
                />
              </div>
              <div class="form-group">
                <label>Margin:</label>
                <input
                  type="number"
                  class="form-control"
                  onChange={stateHandle}
                  name="margin"
                  value={state.margin}
                  placeholder=""
                />
              </div>

              <div class="form-group">
                <label>Effective Date:</label>
                <div class="input-group">
                  <DateRangePicker
                    onCallback={(date) => setDate(date)}
                    initialSettings={{
                      singleDatePicker: true,
                      timePicker: true,
                      showDropdowns: true,
                      startDate: moment(date),
                      locale: {
                        format: "MMMM/DD/YYYY h:mm A",
                      },
                    }}
                  >
                    <input
                      type="text"
                      className="form-control"
                      style={{ minWidth: "300px" }}
                    />
                  </DateRangePicker>
                  <span class="input-group-prepend">
                    {/* <span class="date-input_icon input-cdr-date" ><i class="icon-calendar22 " style={{ color: 'white' }}></i></span> */}
                  </span>
                </div>
              </div>
            </fieldset>
          </div>
          {/* column 2 */}
          <div className="col-md-4">
            <fieldset>
              <legend class="font-weight-semibold">
                <i class="icon-reading mr-2"></i> Details
              </legend>

              <div className="row">
                <div className="col-md-4">
                  <div class="form-group">
                    <label>Toll Free Include:</label>
                    <div class="custom-control custom-checkbox mb-2">
                      <input
                        type="checkbox"
                        class="custom-control-input"
                        onChange={() => setisTollFree(!isTollFree)}
                        id="isTollFree"
                        checked={isTollFree}
                      />
                      <label
                        class="custom-control-label"
                        for="isTollFree"
                      ></label>
                    </div>
                  </div>
                </div>
                <div className="col-md-8">
                  <div class="form-group">
                    <label>Toll Free Price:</label>
                    <input
                      type="number"
                      class="form-control"
                      disabled={isTollFree ? false : true}
                      onChange={stateHandle}
                      name="tollFreePrice"
                      value={state.tollFreePrice}
                      placeholder=""
                    />
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>Build Off Which Carrier Place:</label>
                <Select
                  value={costPlaceSelect}
                  onChange={(costPlaceSelect) =>
                    setCostPlaceSelect(costPlaceSelect)
                  }
                  options={costPlace}
                  className="w-100"
                />
              </div>

              <div class="form-group">
                <label>Min Profit:</label>
                <input
                  type="number"
                  class="form-control"
                  onChange={stateHandle}
                  name="minProfit"
                  value={state.minProfit}
                  placeholder=""
                />
              </div>

              <div className="form-group">
                <label>Populate Indeterminate As:</label>
                <Select
                  value={indeterminateAsSelect}
                  onChange={(indeterminateAsSelect) =>
                    setIndeterminateAsSelect(indeterminateAsSelect)
                  }
                  options={indeterminateAs}
                  className="w-100"
                />
              </div>

              <div class="form-group">
                <label>Rounding Digits:</label>
                <Select
                  value={roundingDigitsSelect}
                  onChange={(roundingDigitsSelect) =>
                    setRoundingDigitSelect(roundingDigitsSelect)
                  }
                  options={roundingDigits}
                  className="w-100"
                />
              </div>
              <div class="form-group">
                <label>Rounding Method:</label>
                <Select
                  value={roundingMethodSelect}
                  onChange={(roundingMethodSelect) =>
                    setRoundingMethodSelect(roundingMethodSelect)
                  }
                  options={roundingMethod}
                  className="w-100"
                />
              </div>
            </fieldset>
          </div>
          {/* column 3 */}
        </div>
        <div className="row">
          <div className="col-md-6 ml-auto">
            <button
              type="submit"
              class="btn btn-success btn-sm main-button float-right"
              disabled={isLoad ? true : false}
              onClick={handleSubmit}
            >
              Create Ratedeck{" "}
              {isLoad ? (
                <i class="icon-spinner4 spinner ml-2"></i>
              ) : (
                <i class="fas fa-plus ml-2"></i>
              )}
            </button>
          </div>
        </div>
      </div>
      <div
        style={{
          border: "none",
          borderRadius: "5px",
          boxShadow: "0 0 20px rgba(0,0,0,.08)",
        }}
        className="card card-body border-left-dark-alpha border-right-dark-alpha "
      >
        <div id="DataTables_Table_0_wrapper" className="no-footer">
          <div className="datatable-header border-0 row">
            <div
              id="DataTables_Table_0_filter"
              className="col-md-6 col-sm-6 col-lg-4 dataTables_filter"
            >
              <div class="input-group">
                <input
                  type="text"
                  class="form-control border-right-0"
                  onChange={searchSpace}
                  value={search}
                  placeholder="Filter file name"
                />

                <span class="input-group-append">
                  <button class="btn search-button" type="button">
                    <i class="fa fa-search"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>

          <div
            className="datatable-scroll"
            style={{ overflowX: "auto", overflowY: "auto", maxHeight: "56em" }}
          >
            <table
              className="table-style table table-striped dataTable no-footer"
              id="DataTables_Table_0"
              role="grid"
              aria-describedby="DataTables_Table_0_info"
            >
              <thead>
                <tr className="stickeyHeader table-heading-style">
                  <th>Carriers</th>
                  <th>File Name</th>
                  <th>TFNs Price</th>
                  <th>Rounding Method</th>
                  <th>Rounding Digits</th>
                  <th>Min profit</th>
                  <th>Max Deviation</th>
                  <th>Margin</th>
                  <th>Indeterminate</th>
                  <th>Include TFNs</th>
                  <th>Create At</th>
                </tr>
              </thead>
              <tbody>
                {isGetting ? <CustomLoader /> : renderAccountTable()}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CreateRateDeckIndex;
